/**
 * Схемы для POST `auth` (логин).
 *
 * Терпимые: `.passthrough()` плюс много `.nullable().optional()` —
 * бэк может варьироваться. Критичны только token + user.id.
 */

import {z} from 'zod';

/* ── Роли (12 штук, из матрицы прав) ────────────────────────────── */

export const UserRoleSchema = z.enum([
  'SUPER_ADMIN',
  'ADMIN',
  'MANAGER',
  'ORGANIZER',
  'ACCOUNTANT',
  'SUPER_CASHIER',
  'CASHIER',
  'PARTNER',
  'ARTIST',
  'CONTROLLER',
  'THEATER_CONTROLLER',
  'EVENT_CONTROLLER',
]);
export type UserRole = z.infer<typeof UserRoleSchema>;

/* ── User ───────────────────────────────────────────────────────── */

export const UserSchema = z
  .object({
    id: z.number(),
    email: z.string().optional(),
    fullName: z.string().nullable().optional(),
    phoneNumber: z.string().nullable().optional(),
    // На реальном бэке `POST auth` НЕ возвращает role у user — роль
    // приходит в каждом Permission-контексте отдельно. Поэтому опционально.
    role: UserRoleSchema.optional(),
    createdAt: z.string().nullable().optional(),
    updatedAt: z.string().nullable().optional(),
  })
  .passthrough();
export type User = z.infer<typeof UserSchema>;

/* ── Request / Response ─────────────────────────────────────────── */

export const LoginRequestSchema = z.object({
  email: z
    .string({required_error: 'Введите email'})
    .min(1, 'Введите email')
    .email('Некорректный email'),
  password: z.string({required_error: 'Введите пароль'}).min(1, 'Введите пароль'),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z
  .object({
    token: z.string(),
    subToken: z.string().nullable().optional(),
    isInvitationsEnabled: z.boolean().optional(),
    user: UserSchema,
  })
  .passthrough();
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
